import {TimeFrame} from "../domain/entities/time-frame.entity";
import {TimeFrameDTO} from "../domain/dtos/time-frame.dto";
import {DateTime} from "luxon";
import {transformer} from "../decorators/transformer.decorator";
import {AbstractDtoToEntityTransformer} from "./abstract-dto-to-entity.transformer";
import {injectable} from "tsyringe";
import {DateHelper} from "../helpers/date.helper";

@injectable()
@transformer({
    source: `dto`,
    target: TimeFrame
})
export class DtoToTimeFrameTransformer extends AbstractDtoToEntityTransformer<TimeFrameDTO, TimeFrame> {

    public toEntity(inputObject: TimeFrameDTO): Promise<TimeFrame> {
        const start = DateHelper.normalizeTimezone(DateTime.fromSQL(inputObject.start));
        const end = DateHelper.normalizeTimezone(DateTime.fromSQL(inputObject.end));

        return Promise.resolve(new TimeFrame(start, end));
    }

}